/**
 * Row and seat number as one label: `A` + `12` → `A12`. When both sides are digits where they meet, a `/`
 * keeps them apart, so `Tisch 2` + `3` reads `Tisch 2/3` instead of `Tisch 23`.
 */
export function seatLabel(
    rowName: string | number | null | undefined,
    positionName: string | number | null | undefined
): string {
    const row = String(rowName ?? '');
    const position = String(positionName ?? '');
    return /\d$/.test(row) && /^\d/.test(position) ? `${row}/${position}` : `${row}${position}`;
}
